import React from 'react';
import { observer } from 'mobx-react';
import classnames from 'classnames';

import GroupShowStore from '../../store/GroupShowStore';
import LiveBroadcastStore from '../../store/LiveBroadcastStore';
import { anchorIsNakedNewsLive } from '../../utils/helpers';
import FANZONE_LOGO from '../../assets/Affiliate/Logos Icons/fanzone_logo.png';
import ANCHOR_BACKGROUND from '../../assets/AnchorPage/background-desktop.png';
import styles from '../../pages/AnchorPage/css/Banner.module.css';

import SocialMediaLinks from './SocialMediaLinks';
import AnchorName from './AnchorName';
import UpcomingShow from './UpcomingShow';
import '../../pages/AnchorPage/css/Anchor.css';
import '../../pages/AnchorPage/css/Anchor.sm.css';
import TipButton from './TipButton';


const AnchorLiveFeed = React.lazy(() => import('./AnchorLiveFeed/AnchorLiveFeed'));


@observer
class Banner extends React.Component {
  anchorHasSocialLinks = () => {
    const { anchor } = this.props;

    return (anchor.facebook !== '' ||
      anchor.twitter !== '' ||
      anchor.snapchat !== '' ||
      anchor.instagram !== '' ||
      anchor.tiktok !== '');
  };

  render() {
    const {
      isPastAnchor,
      anchor,
      anchorVideoUrl,
      user,
      chatService,
      chatServiceTempted,
      guestUser,
      anchorId,
      openContextualOverlay,
      extractIdFromSlug,
      slug,
      history,
      onNetworkError,
      isBanned,
      showFanZone,
      isSpotlighing,
      spotlighedAnchorUsername,
      spotlighedAnchorNickname,
      fetchStreamDetails,
    } = this.props;

    const isWhitelisted = user ? user?.features?.includes('ANCHOR_PORTAL') : false;
    const isAnchor = user?.user?.account?.anchor || false;
    const { anchorSubscriptions } = user?.user?.account || {};
    const isSubscribed = anchorSubscriptions?.find((sub) => sub.subCategory === extractIdFromSlug());
    const onProbation = parseInt(anchorId, 10) === 120;
    const { isInGroupShow } = GroupShowStore;
    const { streamStarted } = LiveBroadcastStore;
    const isNakedNewsLive = anchorIsNakedNewsLive(anchor?.id);

    const shouldShowTipButton = showFanZone && user?.authenticated && !isBanned;

    const canSubscribeToAnchor = (!user.authenticated && showFanZone) ||
      (!isAnchor && !onProbation && !isSubscribed && isWhitelisted && showFanZone);

    const anchorSubscribeButton = () => {
      if (!canSubscribeToAnchor) {
        return null;
      }

      return (
        <div className={styles.anchorSubscribe}>
          <img alt="FAN ZONE" className={styles.fanzoneTitle} src={FANZONE_LOGO} />
          <button
            className={styles.btnCurvedRed}
            onClick={() => openContextualOverlay(true)}
          >
            <span>SUBSCRIBE</span>
          </button>
        </div>
      );
    };
    const shouldRenderLiveFeed = streamStarted && ((anchorVideoUrl && isWhitelisted) || isInGroupShow);

    return (
      <div
        className={
          classnames(
            'masthead',
            styles.anchorBannerContainer,
          )
        }
      >
        {shouldRenderLiveFeed &&
          <React.Suspense fallback={null}>
            <AnchorLiveFeed
              anchor={anchor}
              anchorId={anchorId}
              anchorVideoUrl={anchorVideoUrl}
              background={anchor.promopic}
              canSubscribeToAnchor={canSubscribeToAnchor}
              chatService={chatService}
              chatServiceTempted={chatServiceTempted}
              fetchStreamDetails={fetchStreamDetails}
              guestUser={guestUser}
              history={history}
              isAlreadySubscribedToAnchor={isSubscribed}
              isAnchor={isAnchor}
              isBanned={isBanned}
              isInGroupShow={isInGroupShow}
              isSpotlighing={isSpotlighing}
              isWhitelisted={isWhitelisted}
              openContextualOverlay={openContextualOverlay}
              slug={slug}
              spotlighedAnchorNickname={spotlighedAnchorNickname}
              spotlighedAnchorUsername={spotlighedAnchorUsername}
              user={user}
              onNetworkError={onNetworkError}
            />
          </React.Suspense>
        }
        <div className="container">
          <div className={styles.anchorBanner} style={{ backgroundImage: `url(${ANCHOR_BACKGROUND})` }}>
            <div
              className={styles.anchorBannerImage}
              style={{ backgroundImage: `url(${anchor.image || anchor.biopic})` }}
            />
            <div className={styles.anchorBannerTitleWrapper}>
              <div
                className={
                  classnames(
                    styles.anchorBannerTitle,
                    { [styles.extraMargin]: shouldShowTipButton }
                  )
                }
              >
                <div className={styles.anchorBannerName}>
                  <AnchorName name={anchor.name} />
                  <div className={styles.horizontalDivider} />
                </div>
                {anchorSubscribeButton()}
                <UpcomingShow anchorId={anchorId} />
              </div>
              <SocialMediaLinks
                anchor={anchor}
                hasSocialLinks={this.anchorHasSocialLinks()}
                isNakedNewsLive={isNakedNewsLive}
                isPastAnchor={isPastAnchor}
              />
            </div>
          </div>
          <div className={styles.anchorTip}>
            <TipButton
              anchor={anchor}
              showTipButton={shouldShowTipButton}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default Banner;
